import type { FrontendOnlyPieces } from '../../../hooks/useSettings/WebsiteSettings';
import { WalnutPartnersFooter } from '../Footer';

// Walnut ATB — frontend-only pieces; all data fields live on the backend
export const walnutAtbFrontend: FrontendOnlyPieces = {
  slug: 'walnut-atb',
  Footer: WalnutPartnersFooter,
};
